<template>
  <div class="notify-of-sending">
    <h2 class="notify-of-sending__title">
      {{ title }}
    </h2>

    <div v-if="errors">
      <h2 class="notify-of-sending__title">
        {{ $t('notification.errors') }}
      </h2>
      <p v-for="(error, index) of errors" :key="index">
        {{ error }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotifyOfSending',
  props: ['res'],
  data: () => ({
    notifyData: null
  }),
  computed: {
    title () {
      return `${this.$t('num-of-emails-sent')} ${this.notifyData?.success}`
    },
    errors () {
      return this.notifyData?.errors?.map(error => error)
    }
  },
  mounted () {
    this.notifyData = JSON.parse(this.res)
  }
}
</script>

<style scoped lang="scss">
@use "@/style/variables" as *;

.notify-of-sending {
  color: $text-regular;
  cursor: pointer;

  p {
    font-size: 14px;
    line-height: 1.25;

    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
}

.notify-of-sending__title {
  margin: 24px 0 12px 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 1;
  vertical-align: center;
}
</style>
